var map = {
	"./behance.svg": "cdc4",
	"./codepen.svg": "a20e",
	"./email.svg": "a988",
	"./facebook.svg": "db24",
	"./github.svg": "4d70",
	"./instagram.svg": "ef51",
	"./linkedin.svg": "60eb",
	"./pinterest.svg": "f352"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c1a1";